import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.search";
import "D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from "vue";
import MessageBox from "@/components/message-box";
var weforsys = require("./utils/weforsys").default;
import "normalize.css/normalize.css"; // a modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";
import "./assets/scss/common.scss";
import "@/styles/index.scss"; // global css
import "./assets/scss/theme.scss"; // 主题
import dayjs from "dayjs";
import App from "./App";
import store from "./store";
import router from "./router";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import _i18n from "./lang"; // internationalization
import "./permission"; // permission control
import "./utils/error-log"; // error log
import { message } from "./utils/message";
import "@/views/ef/index.css";
import * as filters from "./filters"; // global filters
import BaiduMap from "vue-baidu-map";

//全局过滤空格
import "@/utils/el-input";
//打印
import Print from "vue-print-nb";
Vue.use(Print);
// 自定义按钮权限指令
import permission from "@/directive/permission";
Vue.use(permission);
Vue.prototype.$dayjs = dayjs;
Vue.use(Element, {
  size: weforsys.storageGet("size") || "small",
  // set element-ui default size
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
Vue.use(BaiduMap, {
  ak: "FD0J5ALYJ03lxFii4SOrlNQLWg16bPuJ" // 替换为你的API Key
});
// 批量引入组件
import components from "./components";
Vue.use(components);

//防止按钮点击过快。 1.5秒后恢复正常
Vue.directive("noMoreClick", {
  inserted: function inserted(el, bing) {
    el.addEventListener("click", function (e) {
      el.classList.add("is-disabled");
      el.disabled = true;
      setTimeout(function () {
        el.disabled = false;
        el.classList.remove("is-disabled");
      }, 1500);
    });
  }
});
//全局回车查询方法
Vue.prototype.$myGlobalMethod = function () {
  // 在这里定义你的全局方法逻辑
  console.log("111");
  var _this = this;
  document.onkeydown = function (e) {
    var keyCode = e.keyCode;
    if (keyCode === 13) {
      _this.search();
    }
  };
};
//全局下拉加属性
Object.defineProperties(Element.Select.props, {
  popperAppendToBody: {
    value: {
      default: false,
      type: Boolean
    }
  }
});
// 添加实例属性
Object.assign(Vue.prototype, {
  define: require("./utils/define"),
  // 常量
  weforsys: weforsys,
  // 公共方法
  formValidate: require("./utils/formValidate").default,
  // 表单验证
  $message: message,
  $confirm: MessageBox.confirm
});

// 全局注册过滤器
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
var vm = new Vue({
  el: "#app",
  router: router,
  store: store,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  }
});
export default vm;